import React, { useState, useEffect } from "react";
import Context from "../../Context";

import { Header } from "../../components/modules";

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/base";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { Switch, useToast } from "../../components/ui";

import { FaPlus } from "react-icons/fa";
import {
  FiHome,
  FiShoppingBag,
  FiCreditCard,
  FiSettings,
  FiGift,
  FiUsers,
  FiUserCheck,
  FiFrown,
  FiVideo,
  FiFileText,
  FiDollarSign,
  FiSmile,
  FiShoppingCart,
} from "react-icons/fi";
import { BiLogIn } from "react-icons/bi";
import { IoReceiptOutline } from "react-icons/io5";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import constant, { statuses } from "../../constants";
import { Spinner } from "reactstrap";
import { MdLockClock } from "react-icons/md";

import {
  unixToDate,
  dateToUnix,
  roundDateToDate,
  unixToDateAndTime,
  resizeImage,
} from "../../util";
import { TimePicker, Spin } from "antd";

import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const General = () => {
  const { callApi, updateConfig, configs } = Context();
  const { toast } = useToast();

  const [loading, setLoading] = useState(false);

  const [saleScheduleDraft, setSaleScheduleDraft] = useState(null);
  const saleSchedule = saleScheduleDraft || configs;
  const changeSaleTime = async (key, date) => {
    if (loading) return;
    const current = saleScheduleDraft;
    const nextSchedule = {
      nextRoundDateTime: configs?.nextRoundDateTime ?? null,
      closeRoundDateTime: configs?.closeRoundDateTime ?? null,
      closeCreateOrderDateTime: configs?.closeCreateOrderDateTime ?? null,
      ...current,
      [key]: date ? date.valueOf() : null,
      roundDate: current ? current.roundDate : configs?.roundDate,
    };
    setSaleScheduleDraft(nextSchedule);
    const { nextRoundDateTime: open, closeRoundDateTime: close, closeCreateOrderDateTime: order } = nextSchedule;
    const error = [open, close, order].some((value) => !Number.isFinite(value) || value <= 0)
      ? "กรุณาเลือกวันและเวลาทั้ง 3 ช่อง"
      : open >= close ? "เวลาเปิดขายต้องก่อนเวลาปิดหน้าร้าน"
        : close > order ? "เวลาปิดสร้างออเดอร์ต้องไม่ก่อนเวลาปิดหน้าร้าน" : null;
    if (error) {
      toast({ className: "bg-[#c15b78]", title: `${error} (ยังไม่บันทึก กรุณาแก้เวลาให้ครบ)` });
      return;
    }
    setLoading(true);
    try {
      const { status, toastMessage } = await callApi("configs-edit", {
        id: "general",
        expectedRoundDate: nextSchedule.roundDate,
        updates: { nextRoundDateTime: open, closeRoundDateTime: close, closeCreateOrderDateTime: order },
      }, { notShowLoading: true });
      if (!status) throw new Error(toastMessage || "บันทึกเวลาไม่สำเร็จ");
      await updateConfig();
      setSaleScheduleDraft(null);
      toast({ className: "bg-[rgb(59,176,101)]", title: "บันทึกเวลาสำเร็จ" });
    } catch (error) {
      toast({ className: "bg-[#c15b78]", title: error.message || "บันทึกเวลาไม่สำเร็จ" });
    } finally {
      setLoading(false);
    }
  };

  const updateChange = async (key, value) => {
    const { status, toastMessage } = await callApi(
      "configs-edit",
      {
        id: "general",
        key: key,
        value: value,
      },
      { notShowLoading: true },
    );

    if (status) {
      toast({
        className: "bg-[rgb(59,176,101)]",
        title: `อัพเดตข้อมูลสำเร็จ`,
      });
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: toastMessage || `อัพเดตข้อมูลไม่สำเร็จ`,
      });
    }
  };
  return (
    <div className="h-fit min-w-[600px] w-full">
      {loading && (
        <div className="absolute w-full col-span-3 border-r border-[#E5E7E9]  z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
          <Spinner className="w-4 h-4" />
        </div>
      )}
      <Header
        header="Settings"
        subHeader={`ตั้งค่า`}
        icon={<FiSettings className="text-blue" />}
      />
      <div className="relative col-span-3 rounded-lg mt-6 overflow-hidden shadow-md bg-white w-full h-fit border border-[#E5E7E9]">
        <div className="p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold text-xl">
            สถานะการทำงานระบบ
            <span className="font-semibold text-xs text-gray-500 ml-2">
              (งวด {roundDateToDate(configs.roundDate)})
            </span>
          </p>
        </div>
        <div className="flex justify-start items-start p-3 gap-2 flex-wrap">
          {/* หน้าร้านขายสลาก */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              const nextState = !configs.isOpen?.store;
              await updateChange("isOpen.store", nextState);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.isOpen?.store
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.isOpen?.store ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">หน้าร้านขายสลาก</p>
            </div>
          </button>

          {/* สร้างคำสั่งซื้อ */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("isOpen.createOrder", !configs.isOpen?.createOrder);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.isOpen?.createOrder
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.isOpen?.createOrder ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">สร้างคำสั่งซื้อ</p>
            </div>
          </button>
          {/* วัน-เวลาเปิดขาย */}
          <div
            className={`relative w-36 h-32 rounded-md bg-gray-100 border border-gray-100 shadow-sm transition-all duration-150 flex flex-col justify-center items-center text-center ${loading
              ? "opacity-60 cursor-not-allowed"
              : "cursor-pointer hover:border-gray-300"
              }`}
          >
            <div className="pointer-events-none">
              <p className="text-sm font-bold text-navy mb-0.5">
                {saleSchedule?.nextRoundDateTime
                  ? dayjs(saleSchedule.nextRoundDateTime).format("DD/MM/YYYY")
                  : "-"}
              </p>
              <p className="text-2xl font-bold text-blue mb-1">
                {saleSchedule?.nextRoundDateTime
                  ? dayjs(saleSchedule.nextRoundDateTime).format("HH:mm")
                  : "--:--"}
              </p>
              <p className="text-xs font-semibold text-gray-500">วัน-เวลาเปิดขาย</p>
            </div>
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format="DD/MM/YYYY HH:mm"
              disabled={loading}
              needConfirm={true}
              value={saleSchedule?.nextRoundDateTime ? dayjs(saleSchedule.nextRoundDateTime) : null}
              onChange={(date) => changeSaleTime("nextRoundDateTime", date)}
              className="absolute inset-0 opacity-0 w-full h-full cursor-pointer"
            />
          </div>

          {/* วัน-เวลาปิดขาย */}
          <div
            className={`relative w-36 h-32 rounded-md bg-gray-100 border border-gray-100 shadow-sm transition-all duration-150 flex flex-col justify-center items-center text-center ${loading
              ? "opacity-60 cursor-not-allowed"
              : "cursor-pointer hover:border-gray-300"
              }`}
          >
            <div className="pointer-events-none">
              <p className="text-sm font-bold text-navy mb-0.5">
                {saleSchedule?.closeRoundDateTime
                  ? dayjs(saleSchedule.closeRoundDateTime).format("DD/MM/YYYY")
                  : "-"}
              </p>
              <p className="text-2xl font-bold text-blue mb-1">
                {saleSchedule?.closeRoundDateTime
                  ? dayjs(saleSchedule.closeRoundDateTime).format("HH:mm")
                  : "--:--"}
              </p>
              <p className="text-xs font-semibold text-gray-500">วัน-เวลาปิดขาย</p>
            </div>
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format="DD/MM/YYYY HH:mm"
              disabled={loading}
              needConfirm={true}
              value={saleSchedule?.closeRoundDateTime ? dayjs(saleSchedule.closeRoundDateTime) : null}
              onChange={(date) => changeSaleTime("closeRoundDateTime", date)}
              className="absolute inset-0 opacity-0 w-full h-full cursor-pointer"
            />
          </div>

          {/* วัน-เวลาปิดสร้างคำสั่งซื้อ */}
          <div
            className={`relative w-36 h-32 rounded-md bg-gray-100 border border-gray-100 shadow-sm transition-all duration-150 flex flex-col justify-center items-center text-center ${loading
              ? "opacity-60 cursor-not-allowed"
              : "cursor-pointer hover:border-gray-300"
              }`}
          >
            <div className="pointer-events-none">
              <p className="text-sm font-bold text-navy mb-0.5">
                {saleSchedule?.closeCreateOrderDateTime
                  ? dayjs(saleSchedule.closeCreateOrderDateTime).format("DD/MM/YYYY")
                  : "-"}
              </p>
              <p className="text-2xl font-bold text-blue mb-1">
                {saleSchedule?.closeCreateOrderDateTime
                  ? dayjs(saleSchedule.closeCreateOrderDateTime).format("HH:mm")
                  : "--:--"}
              </p>
              <p className="text-xs font-semibold text-gray-500">วัน-เวลาปิดสร้างออเดอร์</p>
            </div>
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format="DD/MM/YYYY HH:mm"
              disabled={loading}
              needConfirm={true}
              value={saleSchedule?.closeCreateOrderDateTime ? dayjs(saleSchedule.closeCreateOrderDateTime) : null}
              onChange={(date) => changeSaleTime("closeCreateOrderDateTime", date)}
              className="absolute inset-0 opacity-0 w-full h-full cursor-pointer"
            />
          </div>
          {/* เปิดรับบริจาค */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("isOpen.donate", !configs.isOpen?.donate);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.isOpen?.donate
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.isOpen?.donate ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">รับบริจาค</p>
            </div>
          </button>

          {/* เปิดการทำภารกิจ */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("isOpen.mission", !configs.isOpen?.mission);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.isOpen?.mission
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.isOpen?.mission ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">ทำภารกิจ</p>
            </div>
          </button>


        </div>
      </div>

      <div className="relative mt-3 col-span-3 rounded-lg overflow-hidden shadow-md bg-white min-w-48 w-full h-fit">
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">งวดปัจจุบัน</p>
          <select
            className="border-1 w-fit border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:opacity-65"
            value={configs.roundDate}
            disabled={loading}
            onChange={async (e) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("roundDate", e.target.value);
              setLoading(false);
              updateConfig();
            }}
          >
            {configs.roundDates.map((rounddate) => (
              <option key={rounddate} value={rounddate}>
                {rounddate}
              </option>
            ))}
          </select>
        </div>
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">งวดถัดไป</p>
          <select
            className="border-1 w-fit border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:opacity-65"
            value={configs.nextRoundDate}
            disabled={loading}
            onChange={async (e) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("nextRoundDate", e.target.value);
              setLoading(false);
              updateConfig();
            }}
          >
            {configs.roundDates.map((rounddate) => (
              <option key={rounddate} value={rounddate}>
                {rounddate}
              </option>
            ))}
          </select>
        </div>
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">เพิ่มงวดใหม่</p>
          <DatePicker
            className="border-1 w-fit border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
            // locale={buddhistLocale}
            value={false}
            disabled={loading}
            onChange={async (en, date) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);

              const { status, message } = await callApi(
                "configs-addNewRoundDate",
                {
                  roundDate: date,
                },
                { notShowLoading: true },
              );
              toast({
                className: status ? "bg-green" : "bg-failed",
                title: (
                  <div className="flex gap-2 items-center">
                    {status ? "บันทึกสำเร็จ" : message || "บันทึกไม่สำเร็จ"}
                  </div>
                ),
              });
              setLoading(false);
              updateConfig();
            }}
          />
        </div>

        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">ประกาศรางวัลงวดนี้</p>

          <Switch
            type="switch"
            disabled={!configs || loading}
            checked={configs.isAwardReady}
            onCheckedChange={async (e) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("isAwardReady", e);
              setLoading(false);
              updateConfig();
            }}
          />
        </div>
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">คำนวนคะแนนงวด {configs.roundDate}</p>
          <button
            className="bg-failed font-semibold text-white text-sm rounded-md py-1 px-3 hover:opacity-60 duration-150 disabled:opacity-65"
            disabled={loading}
            onClick={async () => {
              setLoading(true);
              const status = await callApi(
                "points-addRoundedPoint",
                { roundDate: configs.roundDate },
                { notShowLoading: true },
              );
              if (status) {
                toast({
                  className: "bg-[rgb(59,176,101)]",
                  title: `อัพเดตข้อมูลสำเร็จ`,
                });
              } else {
                toast({
                  className: "bg-[#c15b78]",
                  title: `อัพเดตข้อมูลไม่สำเร็จ`,
                });
              }
              setLoading(false);
            }}
          >
            เริ่มคำนวนคะแนน
          </button>
        </div>
      </div>
      {/* Show Button Config Section */}
      <div className="relative mt-3 col-span-3 rounded-lg overflow-hidden shadow-md bg-white w-full h-fit border border-[#E5E7E9]">
        <div className="p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold text-xl">ตั้งค่าปุ่มแสดงผลหน้าบ้าน</p>
        </div>
        <div className="flex justify-start items-start p-3 gap-2 flex-wrap">
          {/* ปุ่มเลขชุด 2 ใบ */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.two", !configs.showButton?.two);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.two
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.two ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขชุด 2 ใบ</p>
            </div>
          </button>

          {/* ปุ่มเลขชุด 3 ใบ */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.three", !configs.showButton?.three);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.three
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.three ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขชุด 3 ใบ</p>
            </div>
          </button>

          {/* ปุ่มเลขชุด 4 ใบ */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.four", !configs.showButton?.four);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.four
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.four ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขชุด 4 ใบ</p>
            </div>
          </button>

          {/* ปุ่มเลขชุด 5 ใบ */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.five", !configs.showButton?.five);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.five
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.five ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขชุด 5 ใบ</p>
            </div>
          </button>

          {/* ปุ่มเลขชุดใหญ่ */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.bigNumber", !configs.showButton?.bigNumber);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.bigNumber
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.bigNumber ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขชุดใหญ่</p>
            </div>
          </button>

          {/* ปุ่มเลขสุ่ม */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.random", !configs.showButton?.random);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.random
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.random ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขสุ่ม</p>
            </div>
          </button>

          {/* ปุ่มเลขหน้าสวย */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.prettyFronts", !configs.showButton?.prettyFronts);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.prettyFronts
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.prettyFronts ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขหน้าสวย</p>
            </div>
          </button>

          {/* ปุ่มเลขเซียนดัง */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.specialNumber", !configs.showButton?.specialNumber);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.specialNumber
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.specialNumber ? "เปิด" : "ปิด"}
              </p>
              <p className="text-xs font-semibold">เลขเซียนดัง</p>
            </div>
          </button>

          {/* ปุ่มเลขบวงสรวง */}
          <button
            type="button"
            disabled={!configs || loading}
            onClick={async () => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("showButton.magicNumber", !configs.showButton?.magicNumber);
              setLoading(false);
              updateConfig();
            }}
            className={`w-36 h-32 rounded-md transition-all duration-150 ${configs?.showButton?.magicNumber
              ? "bg-green border border-gray-100 text-white shadow-md"
              : "bg-gray-100 border border-gray-100 rounded-md text-gray-500"
              } disabled:scale-100 disabled:opacity-75 disabled:cursor-not-allowed`}
          >
            <div>
              <p className="text-3xl font-semibold mb-2">
                {configs?.showButton?.magicNumber ? "เปิด" : "ปิด"}
                <p className="text-xs font-semibold">เลขบวงสรวง</p>
              </p>
            </div>
          </button>
        </div>
      </div>

      <div className="relative mt-3 col-span-3 rounded-lg overflow-hidden shadow-md bg-white min-w-48 w-full h-fit">
        <div className="p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold"> ชื่อเลขบวงสรวง</p>

          <input
            className="border-1 w-full max-w-60 border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
            type="text"
            disabled={loading}
            defaultValue={configs.magicNumber?.name}
            onBlur={async (e) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("magicNumber.name", e.target.value);
              setLoading(false);
              updateConfig();
            }}
            placeholder="ชื่อ"
          />
        </div>

        <div
          className={`p-3 flex justify-between ${configs.magicNumber.image ? "items-start" : "items-center"
            } border-b border-[#E5E7E9]`}
        >
          <p className="font-semibold"> รูปเลขบรวงสรวง</p>
          {configs.magicNumber.image ? (
            // <img
            //   className="max-w-60 border border-gray-300"
            //   src={configs.magicNumber.image}
            //   alt={configs.magicNumber.image}
            // />
            <label htmlFor="magicNumber" className="cursor-pointer">
              <div className="relative">
                <img
                  src={"mock.png"}
                  alt="logo"
                  className="w-80 p-1 sm:p-2 pb-0"
                />
                <div className="absolute flex flex-col justify-start items-center gap-1 top-0 left-0 w-[15%] h-full bg-[rgb(247,211,68)]">
                  <img
                    src={"/images/logo_single.png"}
                    alt="logo"
                    className="w-8 p-2"
                  />

                  <img
                    src={configs.magicNumber.image}
                    alt="magin_number"
                    className="w-full border-2 border-danger"
                  />

                  <div>
                    <p className="text-center px-1 text-navy text-xs font-bold">
                      1 ใบ
                    </p>
                    <p className="text-center px-1 text-navy text-xs font-bold">
                      6 ล้าน
                    </p>
                  </div>
                </div>
              </div>
            </label>
          ) : (
            <button className="bg-blue flex gap-2 items-center rounded-lg py-2 px-3 text-white font-semibold hover:opacity-75 duration-150 disabled:opacity-45 disabled:cursor-not-allowed">
              <FaPlus /> เพิ่ม
            </button>
          )}
        </div>
        <input
          style={{
            marginBottom: "15px",
            visibility: "hidden",
            position: "absolute",
            display: "none",
          }}
          id="magicNumber"
          type="file"
          onChange={async (e) => {
            const file = e.target.files[0];
            const base64 = await resizeImage(file);
            if (base64) {
              setLoading(true);
              const { status } = await callApi(
                "configs-editMagicNumberImage",
                {
                  base64: e.target.value,
                },
              );

              if (status) {
                toast({
                  className: "bg-[rgb(59,176,101)]",
                  title: `อัพเดตข้อมูลสำเร็จ`,
                });
              } else {
                toast({
                  className: "bg-[#c15b78]",
                  title: `อัพเดตข้อมูลไม่สำเร็จ`,
                });
              }

              setLoading(false);
              updateConfig();
            } else {
              alert("อัพโหลด ได้เฉพาะ ไฟล์รูปภาพ นามสกุล jpg หรือ png");
            }
          }}
        />
      </div>
    </div>
  );
};
